/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./channel-column.vue?vue&type=template&id=6c7160c6&"
import script from "./channel-column.vue?vue&type=script&lang=js&"
export * from "./channel-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports